import { useState } from "react";
// MSAL imports
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useProtectedContent } from "../../hooks/useProtectedContent";
// State Import
import { useUserCard } from "../../state/userCardState";
// Components
import { Loading } from "../../components/Loading";
import { SettingsForm } from "./SettingsForm";
import { UserAccess } from "./UserAccess";
import { UserAddress } from "./UserAddress";
import { UserBranches } from "./UserBranches";
import { GenericListHeader } from "../../components/GenericHeader";
import { ComponentAuthorisation } from "../../components/ComponentAuthorisation";
// MUI
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export const UserAccount = () => {
  // MSAL auth request
  const allowOrders = useProtectedContent("alloworders");

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [userCard, setUserCard] = useState({
    userid: "",
    branches: [],
  });
  const { isSuccess, data } = useUserCard();

  // Success Function
  const successFunc = () => setUserCard(data.data.data.data.data.user);
  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <GenericListHeader heading="Account Settings" />

        <Tabs value={value} onChange={handleChange} centered>
          <Tab label="General" />
          <Tab label="Addresses" disabled={!allowOrders} />
          <Tab label="Access" />
          <Tab label="Branches" />
        </Tabs>
        {userCard.userid === "" ? (
          <Loading />
        ) : (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 2,
            }}
          >
            {value === 0 && <SettingsForm userCard={userCard} />}
            {value === 1 && (
              // Addresses require the "alloworders" role.
              <ComponentAuthorisation allowedRoles={["alloworders"]}>
                <UserAddress
                  userCard={userCard}
                  defaultAddressCode={userCard?.defaultshiptocode}
                />
              </ComponentAuthorisation>
            )}
            {value === 2 && <UserAccess userCard={userCard} />}
            {value === 3 && <UserBranches branches={userCard.branches} />}
          </Box>
        )}
      </Box>
    </>
  );
};
